import React from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CityEChallan from "./component";
import { withRouter } from "react-router-dom";
import { fetchOrderData, fetchRegNumberList } from "../e-challan/actions";

const mapStateToProps = ({
    eChallan: {
        stateName,
        stateSlug,
        cmsContent,
        isInvalidState,
        regNumberList,
        recentTransaction,
        isSSR,
        isInvalidCity
    },
    user: {
        isLoggedIn,
        secureToken
    }
}) => ({
    stateName,
    stateSlug,
    isInvalidState,
    cmsContent,
    regNumberList,
    recentTransaction,
    isLoggedIn,
    secureToken,
    isSSR,
    isInvalidCity
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchRegNumberListConnect: fetchRegNumberList,
    fetchOrderDataConnect: fetchOrderData
}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CityEChallan));
